import TIP_CONTENTS, { Tip } from "@/constants/tip";
import { Category } from "@/types/guidebookType";
import { GetStaticPaths, GetStaticPathsResult, GetStaticProps } from "next";
import { Axios } from "@/utils/axios";

import RichSearch from "@/components/common/RichSearch";
import { richSearchData } from "@/constants/richSearch";
import { GuidebookTipContainer } from "@/containers/GuidebookTipContainer";

import { skipDevBuildInGetStaticPaths } from "@/utils/skipDevBuildInGetStaticPaths";
import { GuidebookTipBottomFixedButtonSection } from "@/containers/GuidebookTipContainer/components/GuidebookTipBottomFixedButtonSection";

export const getStaticPaths: GetStaticPaths = async () => {
  const skipBuildResult = skipDevBuildInGetStaticPaths() as GetStaticPathsResult;

  if (skipBuildResult) {
    return skipBuildResult;
  }

  const { data } = await Axios.get(`/articles/paths/`);

  const paths = data.map(({ category, index }: { category: string; index: string }) => ({
    params: {
      category,
      index,
    },
  }));

  return {
    paths,
    fallback: "blocking",
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const category = params?.category as Category;
  const index = params?.index as string;

  let id = -1;
  let content;

  if (category !== "ongoing") {
    id = TIP_CONTENTS[category].findIndex((tip) => tip.index === index);
    content = TIP_CONTENTS[category][id];
  }

  if (id === -1) {
    const slug = `tip-${category}-${index}`;
    const { data } = await Axios.get(`/articles/${slug}/`);

    content = {
      ...data,
      html: data.content,
      callout: { subject: data.callout_subject, minute: data.callout_minute },
    };
  }

  const sliceDescription = content.description.slice(0, 150);
  const pageDescription = sliceDescription;
  const pageKeywords = content.keywords;
  const pageOgTitle = content.title + " - [고이 장례 가이드북]";
  const pageOgDescription = sliceDescription;
  const pageOgImage = `${process.env.NEXT_PUBLIC_CDN_URL}/images/guidebook/tip/thumbnail/${category}/${id}.png`;
  const isFuneralExpense = !(
    content.title.includes("제사") ||
    content.title.includes("유골함") ||
    content.title.includes("부고문자") ||
    content.title.includes("답례문자") ||
    content.title.includes("탈상") ||
    content.title.includes("부조금") ||
    content.title.includes("유골함")
  );
  return {
    props: {
      category,
      id,
      index,
      content,
      isFuneralExpense,
      pageDescription,
      pageKeywords,
      pageOgTitle,
      pageOgDescription,
      pageOgImage,
    },
  };
};

export interface TipIdProps {
  category: Category;
  index: number;
  content: Tip;
  pageOgTitle: string;
  isFuneralExpense?: boolean;
}

function GuidebookTipPage({ category, index, content, pageOgTitle, isFuneralExpense }: TipIdProps) {
  const { videoRichSearch } = richSearchData.guidebook;

  return (
    <>
      {isFuneralExpense && <RichSearch key="video" data={videoRichSearch} />}
      <GuidebookTipContainer
        category={category}
        index={index}
        content={content}
        pageOgTitle={pageOgTitle}
        isFuneralExpense={isFuneralExpense}
      />
      <GuidebookTipBottomFixedButtonSection />
    </>
  );
}

export default GuidebookTipPage;
